import axios from "axios";

export const state = {
    inventoryitems: [],
};

export const getters = {
    expenseitems: state => state.inventoryitems,
};

export const mutations = {
    setInventoryitems(state, newValue) {
        state.inventoryitems = newValue
    },
};

export const actions = {
    fetchInventoryitems({ commit }) {
        axios.get('/inventoryitem').then(res => {
            commit('setInventoryitems', res.data.units)
        })
    },
};
